import React, { useMemo } from 'react'
import FoodItemAdded from './FoodItemAdded'
import DynamicColor from '../common/dynamic-color'
import Button from '../elements/Button'
import FoodSubmited from './FoodSubmited'
import ListFoodWithGroup from '../../containers/order/ListFoodWithGroup'

import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'

const Cart = props => {
    const {
        cartDetails = [],
        handleUpdateAmount,
        setFoodSelected,
        ordered = [],
        handleAddGroupOrder,
        canAddMoreGroup
    } = props
    const { t } = useTranslation()

    return (
        <>
            {!!cartDetails.length && (
                <>
                    <DynamicColor
                        style={{ borderBottomColor: COLOR_NAME.BODY_LINE }}
                        className="cart-details__list-food-added"
                    >
                        {/* {renListFood()} */}
                        <ListFoodWithGroup
                            listFood={cartDetails}
                            scrollToBottomCurrentGroup
                            renderFood={(food, i) =>
                                food.submitted ? (
                                    <FoodSubmited
                                        food={food}
                                        key={`food-ordered-${i}`}
                                    />
                                ) : (
                                    <FoodItemAdded
                                        index={i}
                                        item={food}
                                        key={`food-${food.groupOrder}-${food.foodDetails?.id}`}
                                        handleUpdateAmount={handleUpdateAmount}
                                        setFoodSelected={setFoodSelected}
                                    />
                                )
                            }
                        />
                    </DynamicColor>

                    {canAddMoreGroup && (
                        <div className="text-center mt-4">
                            <Button id="add-group" onClick={handleAddGroupOrder}>
                                {t('cartMobile.btnAddGroupOrder')}
                            </Button>
                        </div>
                    )}
                </>
            )}

            {!cartDetails.length && !ordered.length && (
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="cart-details--empty"
                >
                    {t('cartMobile.lbCartEmpty')}
                </DynamicColor>
            )}
        </>
    )
}

export default Cart
